import { CategoryType } from "enums/category";
import { CategoryModel } from "models";
import React, { ReactNode, useEffect } from "react";
import { Utils } from "utils";

type PROPS = {
  category: CategoryModel[];
  data: {
    apply_item_large_category_id?: string;
    apply_item_medium_category_id?: string;
    apply_item_small_category_id?: string;
  };
  disabled?: boolean;
  children?: ReactNode;
};

const ItemCategoryInputs: React.FC<PROPS> = (props) => {
  const disabled = props.disabled;

  const [larges, setLarges] = React.useState<CategoryModel[]>([]);
  const [midiums, setMidiums] = React.useState<CategoryModel[]>([]);
  const [smalls, setSmalls] = React.useState<CategoryModel[]>([]);

  const [valueL, setValueL] = React.useState("");
  const [valueM, setValueM] = React.useState("");
  const [valueS, setValueS] = React.useState("");

  useEffect(() => {
    setLarges(props.category);
  }, [props.category]);

  useEffect(() => {
    const largeId = props.data.apply_item_large_category_id ?? "";
    const mediumId = props.data.apply_item_medium_category_id ?? "";
    const smallId = props.data.apply_item_small_category_id ?? "";
    let tmp = Utils.Category.pickCategory(largeId, props.category, CategoryType.LARGE);
    if (tmp) {
      setValueL(largeId);
      setMidiums(tmp.list);
    } else {
      setValueL("");
    }
    tmp = Utils.Category.pickCategory(mediumId, props.category, CategoryType.MIDDLE);
    if (tmp) {
      setValueM(mediumId);
      setSmalls(tmp.list);
    } else {
      setValueM("");
    }
    tmp = Utils.Category.pickCategory(smallId, props.category, CategoryType.SMALL);
    setValueS(tmp ? smallId : "");
  }, [props.category, props.data]);

  return (
    <div className="flex-1 flex items-center gap-2">
      <select
        className="flex-1"
        value={valueL}
        onChange={(e) => {
          const value = e.target.value;
          setValueL(value);
          if (value === "") {
            delete props.data.apply_item_large_category_id;
            delete props.data.apply_item_medium_category_id;
            delete props.data.apply_item_small_category_id;
            setValueM("");
            setValueS("");
            setMidiums([]);
            setSmalls([]);
          } else {
            props.data.apply_item_large_category_id = value;
            delete props.data.apply_item_medium_category_id;
            delete props.data.apply_item_small_category_id;
            setValueM("");
            setValueS("");
            const target = Utils.Category.pickCategory(
              value,
              props.category,
              CategoryType.LARGE
            );
            setMidiums(target?.list ?? []);
            setSmalls([]);
          }
        }}
        disabled={disabled}
      >
        <option value="">大分類&nbsp;選択</option>
        {larges.map((v, i) => {
          return (
            <option key={i} value={v.id}>
              {v.name}
            </option>
          );
        })}
      </select>
      <select
        className={`flex-1 ${
          valueL !== "" && !!midiums.length ? "visible" : "invisible"
        }`}
        value={valueM}
        onChange={(e) => {
          const value = e.target.value;
          setValueM(value);
          if (value === "") {
            delete props.data.apply_item_medium_category_id;
            delete props.data.apply_item_small_category_id;
            setValueS("");
            setSmalls([]);
          } else {
            props.data.apply_item_medium_category_id = value;
            delete props.data.apply_item_small_category_id;
            setValueS("");
            const target = Utils.Category.pickCategory(
              value,
              props.category,
              CategoryType.MIDDLE
            );
            setSmalls(target?.list ?? []);
          }
        }}
        disabled={disabled || valueL === ""}
      >
        <option value="">中分類&nbsp;選択しない</option>
        {midiums.map((v, i) => {
          return (
            <option key={i} value={v.id}>
              {v.name}
            </option>
          );
        })}
      </select>
      <select
        className={`flex-1 ${
          valueM !== "" && !!smalls.length ? "visible" : "invisible"
        }`}
        value={valueS}
        onChange={(e) => {
          const value = e.target.value;
          setValueS(value);
          if (value === "") {
            delete props.data.apply_item_small_category_id;
          } else {
            props.data.apply_item_small_category_id = value;
          }
        }}
        disabled={disabled || valueM === ""}
      >
        <option value="">小分類&nbsp;選択しない</option>
        {smalls.map((v, i) => {
          return (
            <option key={i} value={v.id}>
              {v.name}
            </option>
          );
        })}
      </select>
      {props.children}
    </div>
  );
};

export default ItemCategoryInputs;
